import React, {Fragment} from 'react'

const FeatureTwelve2 = () => {
    return (
        <Fragment>
            <div className="block-style-nine color-two">
                <div className="title-style-three pb-10" data-aos="fade-up">
                    <div className="sc-title">WHY CHOOSE US</div>
                    <h2 className="main-title">Why <span>choose us</span> for your business.</h2>
                </div>
                {/* /.title-style-three */}
                <ul className="style-none list-item">
                    <li data-aos="fade-up">Learn content by interacting with an expert lesson or watching a video.</li>
                    <li data-aos="fade-up" data-aos-delay={100}>Practice what you learned on realistic SAT test questions.</li>
                    <li data-aos="fade-up" data-aos-delay={200}>Review your practice questions and learn how to improve.</li>
                </ul>
            </div>
            {/* /.block-style-nine */}
        </Fragment>
    )
}

export default FeatureTwelve2